import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

interface RevenueSplitProps {
  charged: number;
  vendorBilled: number;
  formatCurrency: (value: number) => string;
}

export const RevenueSplit: React.FC<RevenueSplitProps> = ({ charged, vendorBilled, formatCurrency }) => {
  const translate = useTranslate();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
      <Typography variant="caption" sx={{ color: '#606060' }}>
        {`${translate('reports.revenueSplit.collected')}: ${formatCurrency(charged)}`}
      </Typography>
      <Typography variant="caption" sx={{ color: '#606060' }}>
        {`${translate('reports.revenueSplit.vendorBilled')}: ${formatCurrency(vendorBilled)}`}
      </Typography>
    </Box>
  );
};
